/// <reference types="react-scripts" />
import ReactDOM from 'react-dom/client';
import './index.css';
import Mount from './mount';
import { ENVIRONMENT } from 'shared/model';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

if (ENVIRONMENT === 'production' || ENVIRONMENT === 'beta')
  Sentry.init({
    dsn: 'https://4e79b6c8f54a4681839a2252f0f1a81e@o230804.ingest.us.sentry.io/4505154450882560',
    integrations: [new Integrations.BrowserTracing()],
    environment: ENVIRONMENT,
    tracesSampleRate: 0.2
  });

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <div className="px-4 xl:px-20 pt-6 lg:pt-10 xl:pt-16 pb-4 scrollbar-none">
    <Mount
      seconds={0}
      isEmbedAvailable={false}
      selectVoice={() => <></>}
      toggleUpgradeModal={() => {
        alert('upgradeModal');
      }}
      toggleInactivePlanModal={() => {
        alert('inactivePlanModal');
      }}
      isInactivePlan={false}
      toggleFeatureBlockModal={() => {
        alert('featureModal');
      }}
      toggleBuyCreditsModal={() => {
        alert('buy credits modal');
      }}
      updateCallStore={() => {}}
      toggleUploadAvatar={() => {
        alert('uploadAvatar');
      }}
      talkingPhotos={[]}
      customTalkingPhotos={[]}
      toggleCreateAccModal={() => {
        alert('toggleCreateAccModal');
      }}
      isBasePlan={false}
      isChatAvailable={true}
      premiumVoicesAllowed={false}
      productName={'premium'}
      apiKey={'e11066cf-2189-4fd9-b0ac-42401dbd0329'} // dev
      agentKey={'49d01fae-6180-4209-a307-74d745ba0de3'} // dev
    />
  </div>
);
